export default [
  {
    path: 'gestao/loterias',
    name: 'loterias',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Loterias',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Loterias' }
      ]
    }
  },
]